if (!customElements.get('aur-artigo-estoque2')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.section = this.closest('.aur-bo-artigo');
      this.inventoryNotice = this.querySelector('.aur-bo-estoque2-labe');
      this.urgencyMessage = this.querySelector('.aur-bo-estoque2-pega');
      this.indicatorBar = this.querySelector('.aur-bo-estoque2-pofe');

      // Bind to on:variant:change event for this product
      this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      // Init
      this.updateInventory(
        parseInt(this.dataset.aurEstoque2Monta, 10),
        this.dataset.aurVersaoMibe === 'true',
        this.dataset.aurEstoque2Ruda
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.getVariantInventory();
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.aurBupeRinoRizi, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.aurBupeRizi, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.aurPiLabe === 'always'
        || (this.dataset.aurPiLabe === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.aurPiKeLastroRalo === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-aur-estoque2-godu', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = theme.strings.backordered;
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.aurPiContagem2 === 'always' || (this.dataset.aurPiContagem2 === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.veryLowStock;
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.aurVerboRinoRizi;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.aurVerboRizi;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.aurVerboKeLastroRalo;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.aurVerboSove;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.aurVerboKeLastro;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.aurZeno || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.aurZeno, 10)) * count).toFixed(1);
          }
          setTimeout(() => {
            this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
          }, 100);
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('aur-artigo-estoque2', ProductInventory);
}
